import { MatTreeNestedDataSource } from '@angular/material/tree';
import { combineLatest, of, Subscription } from 'rxjs';
import { JsonFormFetcherService } from './../../../../../services/shared/json-form-fetcher.service';
import { FormSaveHelper } from '@modules/policy/services/shared/save';
import { CoverageTableComponent } from './../../../../../shared/components/coverage-table/coverage-table.component';
import { TreeService } from '../../../../../services/location/tree.service';
import { PolicyService } from '../../../../../policy.service';
import { PolicyDataService } from '../../../../../services/shared/policy-data.service';

import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import LocationTabs from '@shared/models/location.model';
import { PolicyState } from '@shared/models/state.model';

@Component({
  selector: 'app-coverage-details',
  templateUrl: './coverage-details.component.html',
  styleUrls: ['./coverage-details.component.scss']
})
export class CoverageDetailsComponent {
  policyID: string;
  tabID: string;
  nodeID: string;
  dataSource: MatTreeNestedDataSource<LocationTabs>;
  subtab: string = "coverageDetails";
  tab: string = "location";
  states: PolicyState;
  listName: string;
  riskStates;
  form: FormGroup = new FormGroup({});
  initSubscription: Subscription;
  @ViewChild("tableComponent", { static: false }) tableComponent: CoverageTableComponent;

  constructor(
    private route: ActivatedRoute,
    private PolicyDataService: PolicyDataService,
    private TreeService: TreeService,
    private PolicyService: PolicyService,
    private FormSaveHelper: FormSaveHelper,
    private JsonFormFetcherService: JsonFormFetcherService
  ) { }

  saveBeforeDeactivate() {
    if (this.PolicyService.getForm(Number(this.nodeID)) == null) {
      return of(null).toPromise();
    }
    const activeForm = (this.tableComponent && this.tableComponent.form)
      ? this.tableComponent.form
      : this.form;
    const runTableSave = () => this.tableComponent
      ? this.tableComponent.saveBeforeDeactivate()
      : of(null).toPromise();

    if (!activeForm.valid) {
      return runTableSave();
    }

    const formId = Number(this.nodeID);
    const cascadingIds: any = {
      nodeState: [formId, true]
    };
    if (this.tab === 'location' && this.states && this.states['location']) {
      const locationId = Number(this.tabID);
      const tree = this.dataSource && this.dataSource.data ? this.dataSource.data : [];
      const riskId = tree.length ? this.TreeService.getParent(tree, formId) : 0;
      if (riskId) {
        cascadingIds.riskState = [riskId, this.TreeService.isRiskValid(riskId, locationId)];
      }
      if (locationId) {
        cascadingIds.locationState = [locationId, this.TreeService.isLocationValid(locationId)];
      }
      cascadingIds.tabState = [
        this.states['location'].id,
        this.PolicyService.getTabForms().location
          ? this.PolicyService.getTabForms().location.valid
          : true
      ];
    }
    return runTableSave().then(() => {
      return this.FormSaveHelper.syncNavigationState(this.policyID, cascadingIds);
    });
  }

  showSaveSnackbar() {
    this.tableComponent.showSaveSnackbar();
    this.tableComponent.updateNavigationTree();
  }

  ngOnInit() {
    this.matTreeSubscription();
    this.policyID = this.PolicyDataService.getPolicyID();
    const tabsObs = this.JsonFormFetcherService.getTabs(this.policyID);
    this.route.params.subscribe(params => {
      if (this.route.snapshot.routeConfig.path.includes("vehicle")) {
        this.tab = "vehicle";
        this.tabID = params["vehicleId"]
      } else if (this.route.snapshot.routeConfig.path.includes("location")) {
        this.tabID = params["locationId"];
      }
      this.nodeID = params["formId"];
      this.initSubscription = combineLatest([this.PolicyDataService.stateSubject, tabsObs]).subscribe(res => {
        const [states, tabs] = res;
        if (this.tab == "location") {
          this.listName = this.PolicyDataService.getListName(this.tab, this.subtab, tabs.tabs);
        }
        this.states = states;
      });
    });
  }

  ngOnDestroy() {
    if (this.initSubscription) {
      this.initSubscription.unsubscribe();
    }
  }

  initForm(form: FormGroup) {
    this.form = form;
  }

  updateNavigationTree() {
    this.PolicyDataService.getPolicyStates(this.policyID).subscribe(tree => {
      this.states = tree;
      this.PolicyDataService.updateStates(tree);
    })
  }

  matTreeSubscription() {
    this.dataSource = new MatTreeNestedDataSource<LocationTabs>();
    this.TreeService.dataSourceSubject.subscribe(data => {
      this.dataSource.data = null;
      this.dataSource.data = data;
    });
  }
}
